@if (showSection) {
  <div class="result-card stuck-card" [class.stuck-card-alert]="totalStuck > 0">
    <div class="result-card-header">
      <h3>
        Stuck Requests
        <span class="count-badge" [class.count-bad]="totalStuck > 0">{{
          totalStuck
        }}</span>
      </h3>
      <div class="result-card-header-actions">
        @if (stuckSummary.isVisibleOnGridCount > 0) {
          <button
            class="action-btn action-btn-danger"
            (click)="fixAllVisibility.emit()">
            Fix All IsVisibleOnGrid ({{ stuckSummary.isVisibleOnGridCount }})
          </button>
        }
        <button
          class="card-refresh-btn"
          (click)="refresh.emit()"
          title="Refresh">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"></polyline>
            <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
          </svg>
        </button>
      </div>
    </div>
    <div class="stuck-summary">
      <div class="stuck-stat">
        <div
          class="stuck-count"
          [class.stuck-count-zero]="stuckSummary.isVisibleOnGridCount === 0">
          {{ stuckSummary.isVisibleOnGridCount }}
        </div>
        <div class="stuck-label">IsVisibleOnGrid = 0</div>
        <div class="stuck-sublabel">older than 30 min</div>
      </div>
      <div class="stuck-stat">
        <div
          class="stuck-count"
          [class.stuck-count-zero]="stuckSummary.isProcessingCount === 0">
          {{ stuckSummary.isProcessingCount }}
        </div>
        <div class="stuck-label">IsProcessing = 1</div>
        <div class="stuck-sublabel">older than 60 min</div>
      </div>
      <div class="stuck-stat">
        <div
          class="stuck-count"
          [class.stuck-count-zero]="stuckSummary.isReady2ProcessCount === 0">
          {{ stuckSummary.isReady2ProcessCount }}
        </div>
        <div class="stuck-label">IsReady2Process = 0</div>
        <div class="stuck-sublabel">older than 30 min</div>
      </div>
      <div class="stuck-stat">
        <div
          class="stuck-count"
          [class.stuck-count-zero]="stuckSummary.isReady4UluroCount === 0">
          {{ stuckSummary.isReady4UluroCount }}
        </div>
        <div class="stuck-label">IsReady4Uluro = 1</div>
        <div class="stuck-sublabel">no transfer &gt; 60 min</div>
      </div>
    </div>
    @if (loading) {
      <div class="spinner">
        <ukg-progress-circular
          size="small"
          indeterminate="true"
          description="Loading Stuck Requests..." />
      </div>
    }
    @if (stuckSummary.totalCount > 0) {
      <div class="stuck-table-top-spacing">
        <div class="table-wrapper">
          <table class="data-table compact">
            <thead>
              <tr>
                <th>Request ID</th>
                <th>AR Number</th>
                <th>Stuck Flag</th>
                <th>Created</th>
                <th>Age</th>
                <th>Created By</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (
                s of stuckSummary.details;
                track trackByStuckRequestId($index, s)
              ) {
                <tr
                  [class.row-mismatch]="s.stuckFlag === 'IsVisibleOnGrid'"
                  [class.row-warn]="s.stuckFlag !== 'IsVisibleOnGrid'">
                  <td class="val">{{ s.requestId }}</td>
                  <td>{{ s.arNumber ?? '—' }}</td>
                  <td>
                    <span
                      class="flag-badge"
                      [class.flag-badge-red]="s.stuckFlag === 'IsVisibleOnGrid'"
                      [class.flag-badge-yellow]="
                        s.stuckFlag !== 'IsVisibleOnGrid'
                      "
                      >{{ getStuckFlagLabel(s.stuckFlag) }}</span
                    >
                  </td>
                  <td>{{ s.stuckSince | date: 'MM/dd/yyyy h:mm a' }}</td>
                  <td class="age-cell">{{ formatAge(s.ageMinutes) }}</td>
                  <td>{{ s.createdBy ?? '—' }}</td>
                  <td>
                    @if (s.stuckFlag === 'IsVisibleOnGrid') {
                      <button
                        class="action-btn"
                        (click)="fixVisibilityForRequest.emit(s.requestId)">
                        Fix
                      </button>
                    }
                    @if (s.stuckFlag === 'IsProcessing') {
                      <button
                        class="action-btn"
                        (click)="
                          releaseProcessingLockForRequest.emit(s.requestId)
                        ">
                        Release Lock
                      </button>
                    }
                    @if (s.stuckFlag === 'IsReady2Process' && s.fileId) {
                      <button
                        class="action-btn action-btn-warn"
                        (click)="markFileReadyForStuck.emit(s.fileId!)">
                        Mark Ready
                      </button>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="pagination-container">
          <div class="page-size-selector">
            <label for="stuckPageSize">Rows per page:</label>
            <select
              id="stuckPageSize"
              [value]="currentPageSize"
              (change)="pageSizeChange.emit($event)">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </select>
          </div>
          <div class="pagination-info">
            Page {{ currentPage }} of {{ totalPages }} ({{ totalCount }} total)
          </div>
          <div class="pagination-controls">
            <button
              class="pagination-btn"
              [disabled]="!hasPrev"
              (click)="pageChange.emit(1)"
              aria-label="First page">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <polyline points="11 17 6 12 11 7"></polyline>
                <polyline points="18 17 13 12 18 7"></polyline>
              </svg>
            </button>
            <button
              class="pagination-btn"
              [disabled]="!hasPrev"
              (click)="pageChange.emit(currentPage - 1)"
              aria-label="Previous page">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>
            <button
              class="pagination-btn"
              [disabled]="!hasNext"
              (click)="pageChange.emit(currentPage + 1)"
              aria-label="Next page">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>
            <button
              class="pagination-btn"
              [disabled]="!hasNext"
              (click)="pageChange.emit(totalPages)"
              aria-label="Last page">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2">
                <polyline points="13 17 18 12 13 7"></polyline>
                <polyline points="6 17 11 12 6 7"></polyline>
              </svg>
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}
